module.exports = __webpack_public_path__ + "img/webinar_image.1ee23bd9.png";